import { createSlice } from "@reduxjs/toolkit";

export const spotmapSlice = createSlice({
    name: 'spotmap',
    initialState: {
        checked: false,
        value: {}
    },
    reducers: {
        setSpotmap: (state, action) => {
            state.value = action.payload;
        },
        setSpotmapChecked: (state, action) => {
            state.checked = action.payload;
        }
    }
})

export const { setSpotmap, setSpotmapChecked } = spotmapSlice.actions;

export const getSpotmap = (state) => state.spotmap.value;
export const getSpotmapChecked = (state) => state.spotmap.checked;

export default spotmapSlice.reducer;